const TRANSLATION = {
  buyModal: {
    afterFree: 'Nakon vašeg besplatnog probnog perioda',
    btn: 'Probajte besplatno',
    freeTrial: '3 dana besplatnog isprobavanja',
    monthLabel: 'mesec',
    selectLabel: 'Odaberite plan',
    title: 'Plan pretplate',
    yearLabel: 'godina',
  },
  contact: {
    block1:
      'Za prilagođavanja, pitanja ili predloge, molimo kontaktirajte nas na contact@noam.tools. Odgovorićemo brzo.',
    block2: 'Podržite nas ocenjujući nas u prodavnici Google Apps ekstenzija sa ★★★★★.',
    block3: 'Pomožite drugima deljenjem ove ekstenzije:',
    title: 'Kontaktirajte nas',
  },
  help: {
    AquickOverviewOfNoam: 'Brzi pregled o Noamu',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Upravljanje omiljenim stavkama',
    Fixedplugin: 'Ispravljeni Dodatak',
    Focusing: 'Fokusiranje',
    Free: 'Besplatan',
    FreeTrialBenefits: 'Prednosti besplatnog probnog perioda',
    GoWithWikipedia: 'Idi na Vikipediju',
    GoWithYouTube: 'Idi sa YouTube-om',
    HoverTranslation: 'Prevod preko miša',
    Howtouse: 'Kako koristiti',
    ImageTranslation: 'Prevod slike',
    InstantTranslation: 'Instantna prevodjenja',
    Membership: 'Članstvo',
    NoamHelp: 'Noam vam pomaže u prevođenju i sažimanju',
    PDFparallelTranslation: 'PDF Paralelno Prevođenje',
    ParallelTranslation: 'Paralelno prevođenje',
    SkipAllSteps: 'Preskoči sve korake',
    Summary: 'Sažetak',
    Translation: 'Prevod',
    TryItForFree: 'Probajte besplatno',
    Video: 'Video',
    VideoSummary: 'Sažetak video zapisa',
    VideoTranslation: 'Prevod videozapisa',
    WebSummary: 'Web Sažetak',
    WordSelectionTranslation: 'Prevod izbora reči',
    benefits: 'Imamo pogodnosti koje čekaju za Vas!',
    dayFree: '3 dana besplatan probni period',
    done: 'Gotovo',
    next: 'Sledeće',
    pin: 'Pinuj Noama za lakši pristup～～',
    planIsNotExist: 'Plan nije dostupan',
    startWiki: 'Počnimo sa Wikimedia-om!',
    startYoutube: 'Počnimo sa YouTube-om!',
    try: 'Isprobajte to',
    tryNow: 'Probajte sada!',
  },
  home: {
    PDFTranslate: {
      desc: 'Dvjezično prevođenje + Chat PDF',
      sub1: {
        desc: 'Dvujezično čitanje vam omogućava poredbeno poređenje originalnog teksta i prevoda, poboljšavajući efikasnost čitanja.',
        title: 'Dvojezično čitanje',
      },
      sub2: {
        desc: 'Umela inteligencija analizira i sažima, kao i može odgovarati na vaše pitanja na osnovu sadržaja PDF-a.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'Prevođenje PDF-a uz podršku umjetne inteligencije za veću točnost i učinkovitost.',
        title: 'Tačnost i Efikasnost',
      },
      title: 'Prevod PDF-a',
    },
    aiAssistant: {
      desc: 'Činjenje web prevoda pametnijim i praktičnijim',
      panel1: {
        desc: 'Dvijezične međusobne reference pri prevodima vam pomažu da uporedate originalni tekst s prevodom, tako da bolje razumijete i poboljšate učinkovitost čitanja.',
        title: 'Dvjezično prevođenje',
      },
      panel2: {
        left: {
          desc: 'Prilikom pregledavanja web stranice, postavite miša preko sadržaja koji treba prevesti da biste videli prevod.',
          title: 'Prevod na letenje',
        },
        right: {
          desc: 'Prilikom pregledanja web stranice, izaberite tekst koji želite prevesti da biste videli prevod.',
          title: 'Prevod izabrane teksta',
        },
      },
      panel3: {
        one: {
          desc: 'Prevodite i sažimajte web stranice i video sadržaj bilo kada, bilo gde, za bolje iskustvo!',
          title: 'Klikni i pokreni',
        },
        three: {
          desc: 'Veliki jezički model vođen umjetnom inteligencijom osigurava točnost i dosljednost prevoda za poboljšanu iskustvo čitanja.',
          title: 'AI-pogonan',
        },
        two: {
          desc: 'Puna podrška za više jezika, dvojjezično čitanje bez barijera, prevod sa jednim klikom - iskusite razliku!',
          title: 'Sveobuhvatniji i praktičniji',
        },
      },
      panel4: {
        tab1: {
          desc: 'Vaš stručnjak za efikasnost - koristeći ChatGPT, Noam prevodi i sažima sadržaj YouTube videozapisa kako bi vam uštedio vrijeme!',
          key: 'Video',
          title: 'Prevod i sažetak video zapisa',
        },
        tab2: {
          desc: 'Kliknite da biste preveli slike prilikom pregledanja web stranica.',
          key: 'Slika',
          title: 'Prevod slike',
        },
        tab3: {
          desc: 'Instantno izvlači ključne informacije s web stranica i pruža sažetak, poboljšavajući vašu efikasnost čitanja.',
          key: 'Web',
          title: 'Prevod i sažetak veb stranice',
        },
        tag1: 'Jednostavan',
        tag2: 'Efikan',
        tag3: 'Lako razumljivo',
      },
      title: 'Asistent AI',
    },
    getStart: 'Započni',
    getStartedForFree: 'Započnite besplatno',
    howItWork: {
      desc: 'Noam integra AI modele kako bi korisnicima pružio inteligentno iskustvo u prevodu i sažetku web stranica na različite jezike, prevodu PDF-a i slika, kao i prevodu i sažetku video sadržaja',
      title: 'Kako radi',
    },
    lastBlock: { desc: 'Bolji AI prevod za glatkije čitanje' },
    top: {
      desc: 'Noam je besplatan AI proširenje za pregledač koje vam pomaže da prevedete i sažete web stranice, video zapise i PDF sadržaj.\n      Pridružite se Noamu i iskusite čaroliju!',
      title1: 'Jedna Magija',
      title2: 'Jedan klik',
    },
    userReviews: {
      desc: 'Recenzije sa pet zvezdica u Chrome Web Store-u',
      title: 'Korisničke recenzije',
    },
  },
  installTips: {
    btn: 'Probajte sada',
    text: 'Instalirajte „Noam Browser Plugin“ da otključate više funkcija! Međusavršeno povezivanje na vebu,\n    sažetak web video zapisa i još mnogo toga!',
  },
  locale: {
    af: 'afrikanski',
    am: 'amharski',
    ar: 'arapski',
    as: 'asamski',
    auto: 'Automatsko prepoznavanje',
    az: 'azerbejdžanski',
    ba: 'baškir',
    bg: 'bugarski',
    bn: 'bangla',
    bo: 'tibetanski',
    bs: 'bosanski',
    ca: 'katalanski',
    cs: ' Češki',
    cy: 'Velški',
    da: 'danski',
    de: 'Njemački',
    dsb: 'Donji sorbski',
    dv: 'Divehi',
    el: 'grčki',
    en: 'engleski jezik',
    es: 'španski',
    et: 'estonijski',
    eu: 'Bask',
    fa: 'persijski',
    fi: 'finski',
    fil: 'Filipinac',
    fj: 'fidžijski',
    fr: 'francuski',
    frCA: 'Francuski (Kanada)',
    ga: 'irski',
    gl: 'galicijski',
    gom: 'Konkani',
    gu: 'guđarati',
    ha: 'hausa',
    he: 'hebrejski',
    hi: 'hindski',
    hr: 'Hrvatski',
    hsb: 'Gornji sorbski',
    ht: 'ajtsko kreolski',
    hu: 'mađarski',
    hy: 'Jermenski',
    id: 'Indonezijski',
    ig: 'Igbo',
    ikt: 'Inuinnaqtun',
    is: 'Islandski',
    it: 'italijanski',
    iu: 'Inuktitut',
    iuLatn: 'Inuktitut (latinica)',
    ja: 'japanski',
    ka: 'gorski',
    kk: 'Kazah',
    km: 'kmerski',
    kmr: 'kurdski (severni)',
    kn: 'kannada',
    ko: 'korejski',
    ku: 'Kurdski (centralni)',
    ky: 'kirgiski',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'litovski',
    lug: 'Ganda',
    lv: 'latvijski',
    lzh: 'Kineski (književni)',
    mai: 'Maithili',
    mg: 'malgaški',
    mi: 'Māori',
    mk: 'makedonski',
    ml: 'malajalami',
    mnCyrl: 'mongolski (ćirilica)',
    mnMong: 'Mongolski (tradicionalni)',
    mr: 'marathi',
    ms: 'malajski',
    mt: 'malteški',
    mww: 'Hmong Daw',
    my: 'Mijanmar (burmanski)',
    nb: 'Norvežanac',
    ne: 'nepalski',
    nl: 'nizozemski',
    noSearchLang: 'Jezik nije podržan',
    nso: 'Sesotho sa Leboa',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'panjabi',
    pl: 'poljski',
    placeholder: 'Pretraga',
    prs: 'Od',
    ps: 'paštunski jezik',
    pt: 'portugalski (Brazil)',
    ptPT: 'portugalski (Portugal)',
    ro: 'romunski',
    ru: 'ruski',
    run: 'Rundi',
    rw: 'kinjarvanski',
    sd: 'sindhi',
    si: 'singalanski',
    sk: 'slovački',
    sl: 'slovenački',
    sm: 'samoański',
    sn: 'šona',
    so: 'Somali',
    sq: 'albanski',
    srCyrl: 'Srpski (ćirilica)',
    srLatn: 'Srpski (latinica)',
    st: 'sesoto',
    sv: 'švedski',
    sw: 'svahili',
    ta: 'tamilski',
    te: 'telugu',
    th: 'tajlandski',
    ti: 'tigrinja',
    tk: 'Turkmen',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'Setsvana',
    to: 'tonganski',
    tr: 'turski',
    tt: 'Tatar',
    ty: 'tahitanski',
    ug: 'Ujguri',
    uk: 'ukrajinski',
    ur: 'urdski',
    uz: 'uzbekski (latinica)',
    vi: 'Vijetnamski',
    xh: 'Xhosa',
    yo: 'joruba',
    yua: 'jukatek maija',
    yue: 'Kantonski (tradicionalni)',
    zh: 'kineski',
    zhHans: 'Kineski pojednostavljeni',
    zhHant: 'Tradicionalni kineski',
    zu: 'Zulu',
  },
  login: {
    and: 'i',
    btn: 'Prijava pomoću Google-a',
    btn1: 'Prijavite se sada',
    desc: 'Prijavite se da biste otključali više iskustava',
    policy: 'Politika privatnosti',
    terms: 'Uslovi korišćenja',
    tips: 'Prijavljujući se, slažem se sa',
    title: 'Dobrodošli u Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Prati', twitter: 'Twitter' },
    legal: { policy: 'Politika privatnosti', terms: 'Uslovi korišćenja', title: 'Legalni' },
    product: {
      image: 'Prevod slike',
      pdf: 'Prevod PDF-a',
      title: 'Proizvodi',
      video: 'Prevod i sažetak videa',
      web: 'Prevođenje i sažetak web stranica',
    },
    resources: { title: 'Resursi' },
    tools: { title: 'Alati', pdf: 'Prevod PDF-a' },
  },
  pageHeader: {
    contact: 'Kontakt',
    help: 'Pomoc',
    logout: 'Odjavi se',
    logoutSucc: 'Odjavljeni ste.',
    pricing: 'Cene',
    settings: 'Postavke',
    signUp: 'Prijavi se',
  },
  pdf: {
    autoDetect: 'Automatsko prepoznavanje',
    cancelBtn: 'Otkaži',
    cancelUpload: 'Otkaži',
    chatPdf: {
      summaryError: 'Sazetak nije uspeo, pokušajte ponovo kasnije',
      chatError: 'Chat nije uspeo, pokušajte ponovo kasnije',
      Search: 'Pretraga',
      cancel: 'Otkaži',
      chatTitle: 'Dobrodošli u Noam! Evo sažetka vašeg PDF-a:',
      clear: 'Jasan',
      clearContent:
        'Ovo će započeti novu konverzaciju. Trenutna konverzacija neće biti sačuvana. Jeste li sigurni?',
      clearDialogTitle: 'Molimo potvrdite',
      clearSucc: 'Očisceno',
      copy: 'Kopiraj',
      copySucc: 'Kopirano',
      delete: 'Obriši',
      deleteCancel: 'Otkaži',
      deleteContent: 'Ovaj PDF ne može se oporaviti nakon brisanja. Jeste li sigurni?',
      deleteOk: 'Obriši',
      deleteSuccess: 'Obrisano',
      deleteTitle: 'Potvrdi brisanje',
      expand: 'Srušenje',
      historyTitle: 'Istorija',
      listError:
        'Nije uspelo učitavanje liste za čitanje. Molimo pokušajte ponovo kasnije ili kontaktirajte podršku.',
      loading: 'Učitavanje...',
      noDataDesc: 'Još nema istorije.',
      noMore: 'Nema više sadržaja.',
      placeholder: 'Pitajte bilo šta o ovom PDF-u',
      summaryTitle: 'Možda ćete biti zainteresovani ovim pitanjima:',
    },
    collectionEmpty: 'Vaša kolekcija je prazna.',
    collectionTab: 'Beleške',
    dataLoading: 'Učitavanje...',
    dialogContent: 'Jeste li sigurni da želite da obrišete ovo?',
    dialogTitle: 'Molimo potvrdite',
    download: {
      both: 'dvojezičan',
      btn: 'Sačuvaj',
      cancel:
        'Zatvaranje ovog prozora će otkazati preuzimanje PDF-a. Jeste li sigurni da želite da otkažete?',
      desc: 'Sačuvaj na uređaj: Preuzima prevode kao slike; Sačuvaj i isprintaj: Preuzima prevode u originalnom formatu, sa podrškom za kopiranje.',
      download: 'Preuzmi',
      downloadMsg1: 'Napredak prevoda PDF-a:',
      downloadMsg2: 'Procenjeno preostalo vrijeme:',
      downloadSucc: 'PDF je spreman! Kliknite da sačuvate.',
      downloadTip:
        'Preuzimanje PDF-a. Ne zatvarajte ovaj prozor kako biste izbegli greške prilikom preuzimanja.',
      error: 'Snimanje nije uspelo. Probajte umesto toga štampanje.',
      fileName: 'Naziv fajla:',
      fileType: 'Tip datoteke:',
      loading: 'Čuvanje...',
      loading2: 'Učitavanje...',
      minute: 'Minuti...',
      msg1: 'Neke prevode u ovom dokumentu su duži od originalnog teksta i mogu se preklapati u preuzetoj datoteci. Preporučujemo čitanje na veb stranici.',
      msg2: 'Prevod još nije završen. Preuzmite nakon što se prevod završi.',
      msg3: '2. Neke prevode su preduge. Čitajte na veb stranici kako biste izbegli preklapanje teksta.',
      msg4: 'Prevodilačke zadatke su u toku. Molimo pokušajte ponovo nakon što se završe.',
      progress:
        'Prevođenje PDF-a. Napredak: {{progress}}, Procijenjeno preostalo vrijeme: {{minutes}} minuta...',
      save: 'Sačuvaj na uređaj',
      savePrint: 'Sačuvaj i štampaj',
      success: 'Preuzeto',
      trans: 'Samo prevod',
      transContinue: 'Nastavite prevođenje',
    },
    downloadBtn: 'Preuzmi',
    dragTipModal: {
      black: 'prostor',
      leftKey: 'levi dugme',
      ok: 'Uspelo',
      press: 'Pritisnite',
      tips: 'prevlačiti i pregledati',
    },
    entry: 'PDF-ovi',
    fileErrMsg:
      'Čitanje datoteke nije uspelo. Molimo pokušajte ponovo kasnije ili kontaktirajte podršku.',
    fileMsg: 'Trenutna veličina datoteke:',
    fileMsg2: 'Molimo Vas da postavite datoteku veličine manju od 300MB.',
    freeBannerBtn: 'Upgrade',
    freeBannerTips: 'Dostignut je limit besplatnih prevoda PDF-a',
    guide: {
      placeholder: 'Umetnite vezu ka PDF-u ovde',
      start: 'Počni prevod',
      text1: 'Dvojezično čitanje',
      text2:
        'Čitaj dvjjezno kako biste uporedili originalni tekst i prevod strana uz stranu, povećavajući svoju učinkovitost.',
      text3: 'Razgovarajte sa svojim PDF-om',
      text4:
        'Analiza i sažimanje podržano umjetnom inteligencijom. Postavite pitanja o vašem PDF-u i dobijte trenutne odgovore.',
      text5: 'Tačan i Efikasan',
      text6: 'Prevod PDF-a podržan AI-om za veću tačnost i efikasnost.',
      title1: 'Dvujezično prevođenje',
      title2: 'Razgovarajte sa svojim PDF-om',
      toast: 'Unesite validan online PDF link koji završava sa .pdf',
    },
    hasTransTask: 'Prevod zadat je u toku. Molimo sačekajte.',
    hoverTrans: 'Paragrafi za prevod preko miša',
    initial: 'Prevedi PDF',
    installText: 'Vaše sve u jednom rešenje za svakodnevne prevode.',
    installText2: 'Prvo instalirajte ekstenziju',
    installTips:
      'Instalirajte proširenje za još više prevoda PDF-a i glatkije prevode web stranica:',
    kw: 'glava za štapling',
    link: 'link',
    listError:
      'Nije uspelo učitavanje PDF-a. Molimo pokušajte ponovo kasnije ili kontaktirajte podršku.',
    memoTotalCount: 'ukupno 1 stavka',
    new: 'novi fajl',
    noId: 'ID fajla nije pronađen.',
    notPdf: 'Samo PDF datoteke.',
    okBtn: 'Obriši',
    okBtn2: 'Uspelo',
    original:
      'Vi ste visoko tačan i pouzdan AI dizajniran da generiše JSON izlaz koji se potpuno uklapa u specificirani JSON šemu.\n\nMorate pratiti ove pravila:\n1. Strogo se pridržavajte strukture JSON šeme.\n2. Točno podudarajte sve tipove podataka, obavezne polja i ograničenja.\n3. NE uključujte nikakav dodatni tekst, objašnjenje, markdown ili komentare.\n4. Ispišite SAMO JSON objekat — bez blokova koda, bez prethodnog teksta, bez omotača.\n\nInformacije o šemi su date ispod.\n- Ime šeme: translate_result\n- JSON šema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Paralelno',
    parseErrDialogContent:
      'Ovaj PDF link ne može se prevesti direktno. Preuzmite PDF i postavite ga za prevođenje.',
    parseErrTips: 'Neuspelo parsiranje datoteke',
    parseFileToast:
      'Neuspešno parsiranje datoteke. Molimo pokušajte ponovo kasnije ili kontaktirajte podršku.',
    pdfLoading: 'Parsiranje...',
    searchPlaceholder: 'Pretraga',
    selectTrans: 'Odaberite tekst za prevođenje',
    shareBtn: 'Podeli',
    shareBtnText1: 'Generiši link za deljenje',
    shareBtnText2: 'Ažuriraj deljeni sadržaj',
    shareModal: {
      cancel: 'Otkaži',
      copy: 'Kopiraj',
      copySucc: 'Link kopiran',
      custom: 'Prilagodite:',
      errMsg: 'Odabrani sadržaj još nije potpuno preveden. Prevedite ga pre deljenja.',
      gen: 'Podeli',
      modify: 'Uredi',
      notSupport: 'Ovaj jezik trenutno nije podržan.',
      page: 'Stranice',
      pageNuErr: 'Unesite ispravan broj stranice.',
      range: 'Opseg:',
      remain: 'preostalo',
      remain1: 'Ukupno procenjeno vreme:',
      search: 'Pretraga',
      settings: 'Podešavanja deljenja:',
      shareSetting: 'Podešavanja deljenja',
      shareText: 'Podeli',
      shareTips: 'Podelite link preveđenog PDF-a sa svojim prijateljima:',
      sourceLang: 'Od:',
      target: 'Za:',
      text1: 'Podešavanja deljenja',
      text2: 'Generiši link za deljenje',
      totalPage: 'Ukupno 1 strana',
      trans: 'Prevedi',
      translateTips:
        'Savet: Ako prevod traje duže, možete zatvoriti ovaj prozor i podeliti kasnije.',
      translating: 'Prevod PDF-a...',
      update: 'Ažuriraj link za deljenje',
    },
    shareMsg1: 'Generisan link za deljenje.',
    shareMsg2: 'Deljeni sadržaj ažuriran.',
    shareMsg3:
      'Nije uspelo generisanje linka za deljenje. Molimo pokušajte ponovo kasnije ili kontaktirajte podršku.',
    shareMsg4:
      'Nije uspelo ažuriranje deljenog sadržaja. Pokušajte ponovo kasnije ili kontaktirajte podršku.',
    shareTips: 'Vaša PDF prevodjenja je spremna! Podelite je sa prijateljima.',
    start: 'Započnite besplatnu probnu period',
    thumbnail: 'Sadržaj',
    toast1: 'Učitavanje PDF-a. Molimo pokušajte ponovo kasnije.',
    toast2: 'Sadržaj PDF-a se obrađuje. Dijalog trenutno nije podržan.',
    toast3: 'Preuzimanje u toku. Pokušajte ponovo nakon što se preuzimanje završi.',
    toolbar: { Adjust: 'Prilagoditi', autoFit: 'Automatsko prilagođavanje' },
    trans: 'Prevod',
    transSucc: 'Prevod uspješan!',
    unLoginToast: 'Molimo prijavite se da biste koristili ovu funkciju.',
    uploadBtn: 'Postavljanje',
    uploadErr: 'Upload fajla nije uspeo. Pokušajte ponovo kasnije ili kontaktirajte podršku.',
    uploadErrSignUrl:
      'Nije moguće dobiti URL za otpremanje. Pokušajte ponovo kasnije ili se obratite podršci.',
    uploadMsg1: 'Prevucite i ispustite svoj fajl ovde.',
    uploadMsg2: 'Podržani tipovi datoteka: PDF  |  Maksimalna veličina datoteke: 300MB',
    uploadMsg3: 'Kliknite da biste izabrali ili prevucite i ispustite datoteke ovde.',
    uploading: 'Postavljanje',
    uploadingMsg: 'Učitavanje. Molimo sačekajte.',
    uploadingMsg1: 'Datoteka se postavlja. Pokušajte ponovo kasnije.',
    uploadingMsg2: 'Datoteka se trenutno konvertuje. Pokušajte ponovo kasnije.',
    uploadingMsg3:
      'Zahtev za napredak konverzije nije uspeo. Pokušajte ponovo kasnije ili se obratite podršci.',
    uploadingMsg4:
      'Noam ne može pristupiti lokalnim datotekama. Molimo ručno prenesite PDF za prevođenje.',
    uploadingMsg5:
      'Nije moguće preuzeti URL datoteke. Pokušajte ponovo kasnije ili kontaktirajte podršku.',
    video: 'video',
    vipBannerBtn: 'Upgrade',
    vipBannerTips: 'Dosegli ste limit prevoda PDF-a za ovaj mesec.',
    webTrans: 'Puna međusadržajna referenca',
  },
  pricing: {
    FAQ: 'Često postavljana pitanja',
    FQAObj: {
      a1: 'Da, Noam nudi besplatan plan koji možete koristiti odmah.',
      a2: 'Pružamo tri plana članstva: Pro, Pro+ i Enterprise. Možete odabrati mesečnu ili godišnju naplatu. Godišnja naplata nudi značajne uštede.',
      a3: 'Sve funkcije su dostupne i u oba paketa. Glavna razlika je cena: godišnje pretplate ukupno koštaju manje. Mesečne pretplate se računaju svakog meseca, dok se godišnja paketa računaju jednom godišnje.',
      a4: 'Možete otkazati svoj pretplatu u bilo koje vreme u podešavanjima naloga.',
      q1: 'Postoji li besplatan plan?',
      q2: 'Koja su dostupna cenovna načela i opcije plaćanja?',
      q3: 'Koja je razlika između mesečne i godišnje pretplate?',
      q4: 'Kako otkazujem svoju pretplatu?',
    },
    around: 'Okolo',
    billedMonthly: 'Račun po mesecu',
    billedYearly: 'Naplaćuje se godišnje',
    day: 'dan',
    desc: 'Uporedite planove i izaberite najbolji',
    detailedCompare: 'Uporedite planove',
    discount: '20% popusta',
    enterprise: {
      benefit1: 'Prioritetno podrška kupcima',
      benefit2: 'Više korisnika',
      benefit3: 'Prilagođena rešenja',
      benefit5: 'Dodeljeni menadžer računa',
      btn: 'Kontaktirajte nas',
      recommendText: 'Prilagođeni planovi (≥3 osobe)',
      talkToUs: 'Kontaktirajte nas',
    },
    free: {
      benefit1: 'Brza prevod 100 puta dana',
      benefit2: 'Prevod i sažetak web sajta',
      benefit3: '30 prevoda slika',
      benefit4: 'Prevod i sažetak videa',
      benefit5: '10 PDF prevoda',
      benefit6: '5.000 tokena',
      btn: 'Probajte besplatno',
      recommendText: 'Besplatan probni period',
    },
    imageTranslation: 'Prevođenje slika',
    month: 'mesec',
    monthly: 'Mesečno',
    pageTitle: 'Cene',
    pdf: {
      chat: 'Upiti za PDF Chat',
      maxPage: 'Maks. strana po PDF-u',
      translation: 'Prevod PDF-a',
    },
    preMonth: 'Po mesecu',
    pro: {
      benefit1: 'Prioritetno podrška kupcima',
      benefit2: '1.000.000 tokena/mesec',
      benefit3: 'Prevod i sažetak web stranice',
      benefit4: '200 prevoda slika',
      benefit5: 'Prevod i sažetak videa',
      benefit6: '200 PDF prevoda',
      btn: 'Počni',
      recommendText: 'Najpopularniji',
    },
    proPlus: {
      benefit1: 'Prioritetno podrška korisnicima',
      benefit2: '3.000.000 tokena/mesec',
      benefit3: 'Prevod i sažetak web sajta',
      benefit4: '500 prevoda slika',
      benefit5: 'Prevod i sažetak video zapisa',
      benefit6: '500 PDF prevoda',
      recommendText: 'Najbolja vrednost',
    },
    video: { summary: 'Sažetak videa', translation: 'Prevod video zapisa' },
    web: {
      contrastiveTranslation: 'Dvjezično prevođenje',
      dictionaryTranslation: 'Selekcija Prevod',
      hoverTranslation: 'Prevod na lebdanju',
      instantTranslation: 'Brza prevodjenja',
      summary: 'Sažetak web stranice',
    },
    yearly: 'Godišnje',
  },
  privacy: {
    block1:
      'Noam ("Noam", "mi", "naš" ili "nama") poštuje vašu privatnost i predan je zaštiti bilo kojih informacija koje dobijemo od vas ili o vama. Ova Politika privatnosti opisuje naše prakse u vezi sa prikupljanjem ili korišćenjem ličnih podataka prilikom korišćenja naše web stranice, aplikacija i usluga (zajednički "Usluge"). Ova Politika privatnosti ne primenjuje se na sadržaj koji obrađujemo u ime naših poslovnih kupaca proizvoda, kao što je naš API. Korišćenje ovih podataka podložno je našoj ugovorni dokumentaciji sa kupcima, koja obuhvata pristup i korišćenje ovih proizvoda.',
    block10:
      'Primenjujemo komercijalno razumne tehničke, administrativne i organizacione mere kako bismo zaštitili online i offline lične podatke od gubitka, neovlašćenog korišćenja, neovlašćenog pristupa, otkrivanja, izmenjivanja ili neprijateljskih radnji. Međutim, nijedna internet ili email transmisija ne može garantovati potpunu sigurnost ili tačnost. Konkretno, emailovi poslate nam ili od nas možda nisu sigurni. Stoga trebate biti posebno oprezni kada odlučujete koje informacije ćete nam poslati putem usluge ili emaila. Dodatno, nismo odgovorni za bilo kakvo ometanje podešavanja privatnosti ili sigurnosnih mera u usluzi ili sigurnosnih podešavanja ili mera trećih strana. Čuvaćemo vaše lične podatke dok god bude potrebno da vam pružimo usluge ili za druge legitimne poslovne svrhe, kao što su rješavanje sporova, razlozi sigurnosti i bezbednosti ili postupanje u skladu sa našim pravnim obavezama. Trajanje čuvanja ličnih podataka zavisiće od mnogih faktora, kao što su količina, priroda, osjetljivost informacija, potencijalni rizici neovlašćenog korišćenja ili otkrivanja, svrhe za koje obrađujemo informacije i druge pravno obavezujuće razmatranja.',
    block11:
      'Ovu Politiku privatnosti možemo ažurirati s vremena na vrijeme. Kada to učinimo, objaviti ćemo ažuriranu verziju na ovoj stranici, osim ako primjena zakona ne zahtijeva drugačije.',
    block12:
      'Ako imate neodgovorena pitanja ili sumnje u vezi sa ovom Politikom privatnosti, molimo kontaktirajte našu službu za korisnike. Email:',
    block2: 'Sakupljamo sledeće lične podatke ("Lični podaci") koji se odnose na Vas:',
    block3:
      'Informacije koje ste Vi pružili: Kada kreirate nalog za korišćenje naših usluga ili komunicirate sa nama, prikupljamo lične informacije na sledeći način:',
    block4:
      'Lični podaci automatski primljeni prilikom korišćenja usluga: Kada pristupate, koristite ili komunicirate sa uslugama, primamo sledeće informacije o vašem pristupu, korišćenju ili komunikaciji ("Tehničke informacije"):',
    block5: 'Možemo koristiti lične podatke u sledeće svrhe:',
    block6:
      'Sažetak ili deidentifikovana informacija: Možemo agregirati ili deidentifikovati lične informacije kako bismo sprečili njihovo ponovno korišćenje u svrhu identifikacije i koristiti takve informacije za analizu efikasnosti naših usluga, poboljšanje i dodavanje funkcija naših usluga, provođenje istraživanja i za slične svrhe. Pored toga, možemo analizirati opšte ponašanje i karakteristike korisnika naših usluga te deliti agregirane informacije sa trećim stranama, objavljivati takve agregirane informacije ili ih činiti opšte dostupnim. Možemo prikupljati agregirane informacije putem usluga, putem kolačića (cookies) i putem drugih načina opisanych u ovoj Politici privatnosti. Deidentifikovane informacije ćemo održavati i koristiti u anonimnoj ili deidentifikovanej formi, i nećemo pokušavati da ih ponovo identifikujemo osim ako to zakonom nije zahtevano.',
    block7:
      'U određenim slučajevima, vaše lične podatke možemo pružiti trećim stranama bez daljeg obaveštenja o vama, osim ako to zakonom nije zahtevano:',
    block8:
      'U zavisnosti od vaše geografske lokacije, pojedinci u Evropskom ekonomskom prostoru, Ujedinjenom Kraljevstvu i širom sveta mogu imati određena zakonska prava u vezi sa svojim ličnim podacima. Na primer, možete imati pravo da:',
    block9:
      'Usluga može sadržati linkove ka drugim veb-sajtima koje Noam ne upravlja ili ne kontroliše, uključujući usluge društvenih medija ("Veb-sajtovi treće strane"). Informacije koje dele s Veb-sajtovima treće strane regulišu se specifičnim politikama privatnosti i uslovima korišćenja tih sajtova, a ne ovom Politikom privatnosti. Ovi linkovi pružaju se radi udobnosti i ne impliciraju naše potvrđivanje ili pregled ovih sajtova. Za informacije o njihovim politikama privatnosti i uslovima, molimo da se direktno obratite Veb-sajtovima treće strane.',
    subBlock1:
      'Informacije o nalogu: Kada kreirate nalog na našoj platformi, prikupljamo informacije vezane za vaš nalog, uključujući vaše ime, kontakt informacije, poverenja za nalog, informacije o platnom karticu i istoriju transakcija ("Informacije o nalogu").',
    subBlock10: ' pružanje, upravljanje, održavanje i/ili analiza usluga;',
    subBlock11: 'Komunikacija sa tobom',
    subBlock12: 'Razvoj novih proizvoda i usluga;',
    subBlock13:
      'Prevencija lažnih postupaka, kriminalnih dela ili zloupotrebe naših usluga, kao i zaštita bezbednosti naših IT sistema, arhitekture i mreža;',
    subBlock14: 'Izvođenje prebacivanja poslovanja;',
    subBlock15:
      'Poštivanje pravnih obaveza i pravnih postupaka, zaštita naših prava, privatnosti, bezbednosti ili imovine, kao i onih naših pridruženih društava, vaših ili drugih trećih lica.',
    subBlock16:
      'Dobavljači i pružaoci usluga: Kako bi nam pomogli da zadovoljimo potrebe poslovne operacije i obavimo određene usluge i funkcije, možemo pružati lične podatke dobavljačima i pružaocima usluga, uključujući pružače hosting usluga, pružače cloud usluga i druge pružače informaciono-tehnoloških usluga, softver za email komunikaciju, pružače usluga web analitike itd. Ovi partneri će pristupati, obrađivati ili čuvati lične podatke samo prema našoj uputi prilikom obavljanja svojih dužnosti za nas.',
    subBlock17:
      'Poslovni prenos: Ako se uključimo u strateške transakcije, reorganizacije, bankrotte, preuzimanja u bankrotu ili prelaz usluga na drugog pružatelja (ukupno "Transakcije"), vaše lične podatke i druge informacije možemo podeliti sa transakcionim partnerima i drugim stranama koje pomoću u Transakcijama tokom due diligence-a, kao i preneti kao deo Transakcija zajedno sa drugim sredstvima nasledničkoj ili pridruženoj kompaniji.',
    subBlock18:
      'Zakonite zahtevi: Možemo deliti vaše lične podatke sa vladinim organima, peer-ovima iz industrije ili drugim trećim stranama, uključujući informacije o vašoj interakciji sa našim servisima, (1) ako je to zahtevano zakonom ili ako vjerujemo da je takva akcija neophodna kako bismo ispunili zakonske obaveze; (2) za zaštitu i brane naših prava ili imovine; (3) ako unilaterally utvrdimo da postoji kršenje naših uslova, politika ili zakona; (4) za otkrivanje ili sprečavanje prevare ili drugih nezakonitih aktivnosti; (5) za zaštitu naših proizvoda, zaposlenih ili korisnika, ili javne bezbednosti, sigurnosti, integriteta; ili (vi) za odbranu od zakonske odgovornosti.',
    subBlock19: 'Pristupite vašoj ličnoj informaciji i informacijama o tome kako se ona obrađuje.',
    subBlock2:
      'Kada koristite naše usluge, prikupljamo lične podatke iz vaših unosa, uploadovanih datoteka ili povratnih informacija koje nam pružate („Sadržaj“).',
    subBlock20: 'Zahtevajte brisanje vaših ličnih podataka iz naših evidencija.',
    subBlock21: 'Ispravite ili ažurirajte vaše lične podatke.',
    subBlock22: 'Prenosite vaše lične podatke trećoj strani (prenosivost podataka).',
    subBlock23: 'Ograničite načine na koje obrađujemo vaše lične podatke.',
    subBlock24:
      'Uklonite vašu pristanak — gde se oslanjamo na pristanak kao pravni osnovu za obradu, možete ukloniti svoj pristanak u bilo koje vreme.',
    subBlock25: 'Prigovorite se na način na koji obrađujemo vaše lične podatke.',
    subBlock26: 'Unapređivanje naših usluga i provođenje istraživanja;',
    subBlock3:
      'Informacije o komunikaciji: Ako nam šaljete poruke, mi ćemo prikupiti vaše ime, kontakt informacije i sadržaj vaših poruka („Informacije o komunikaciji“).',
    subBlock4:
      'Informacije o društvenim medijima: Imamo stranice na veb-sajtima društvenih medija kao što su Instagram, Facebook, Medium, Twitter, YouTube i LinkedIn. Kada interagujete sa našim stranicama na društvenim medijima, prikupljamo lične podatke koje odlučite da nam pružite, kao što su vaši kontakt podaci („Društveni podaci“). Pored toga, kompanije koje hostuju naše stranice na društvenim medijima možda nam pruže agregirane informacije i analizu o našim aktivnostima na društvenim medijima.',
    subBlock5:
      'Podaci o dnevniku: Informacije koje vaš pretraživač automatski šalje prilikom korišćenja naših usluga. Podaci o dnevniku uključuju vašu Internet Protocol (IP) adresu, vrstu i podešavanja pretraživača, datum i vreme vaših zahteva, kao i način na koji interagujete sa našom web stranicom.',
    subBlock6:
      'Podaci o upotrebi: Možemo automatski prikupljati informacije o vašoj upotrebi usluge, kao što su vrste sadržaja koje pregledate ili sa kojima interagujete, funkcije koje koristite, akcije koje preduzimate, kao i vaša vremenska zona, država, datum i vrijeme pristupa, korisnički agent i verzija, tip računara ili mobilnog uređaja te vaša računarska veza.',
    subBlock7:
      'Informacije o uređaju: Ovo uključuje naziv uređaja, operativni sistem, identifikator uređaja i pretraživač koji koristite. Prikupljena informacija može zavisiti od tipa uređaja koji koristite i njegovih postavki.',
    subBlock8:
      'Kolačići: Koristimo kolačiće za rad i upravljanje našim servisima te poboljšanje vaše iskustva. "Kolačić" je informacija koju web stranica koju posetite šalje vašem pregledaču. Možete podesiti pregledač da prihvati sve kolačiće, odbije sve kolačiće ili vas obavesti kada se kolačić nudi kako biste svaki put mogli odlučiti da li ga prihvatite. Međutim, odbijanje kolačića može spriječiti vas da koristite ili negativno uticati na prikaz ili funkcionalnost određenih područja ili značajki web stranice. Za više informacija o kolačićima, posetite All About Cookies.',
    subBlock9:
      'Analitika: Možemo koristiti različite online alate za analitiku koji koriste kolačiće kako bismo analizirali kako korisnici koriste naše usluge i poboljšali vaše iskustvo prilikom korišćenja usluga.',
    subTitle1: 'Lične informacije koje prikupljamo',
    subTitle2: 'Kako koristimo lične podatke',
    subTitle3: 'Otvaranje ličnih podataka',
    subTitle4: 'Vaši prava',
    subTitle5: 'Linkovi ka drugim veb-sajtima',
    subTitle6: 'Sigurnost i zadržavanje informacija',
    subTitle7: 'Izmene Politike privatnosti',
    subTitle8: 'Kako nas kontaktirati',
    title: 'Politika privatnosti',
    updateTime: 'Ažurirano: 15. mart 2024.',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Prihvati sve',
    text: 'Da bismo poboljšali vaše iskustvo, koristimo kolačiće za personalizaciju sadržaja i usluga.',
    title: 'Ovaj sajt koristi kolačiće',
  },
  slogen: 'Najlakši AI asistent',
  stripe: {
    contact: 'Kontaktirajte nas na contact@noam.tools za bilo kakva pitanja!',
    fail: {
      btn: 'Pokušajte ponovo',
      text1: 'Nismo mogli obraditi Vašu uplatu.',
      text2: 'Proverite vašu vezu i pokušajte ponovo.',
      title: 'Platnja nije uspela',
    },
    succ: { btn: 'Hajde', text1: 'Dobrodošli u Noam', text2: 'Počnimo!', title: 'Čestitke' },
  },
  terms: {
    block1: 'Hvala što koristite Noam!',
    block10:
      '(a) Naknade i Računovodstvo. Plaćaćete sve naknade ("Naknade") prema cenovniku i uslovima na odgovarajućoj stranici sa cenama ili onako kako se dogovorimo u pismu. Zadržavamo pravo da ispravimo greške u cenama čak i ako smo izdali račune ili primili plaćanje. Pruvićete potpune i tačne podatke za računovodstvo, uključujući važeću i ovlašćenu metodu plaćanja. Naplativaćemo vašu metodu plaćanja periodično kako se dogovorimo, ali možemo razumnogodno promeniti datum naplate. Ovlašćujete Noam, njegove afilijate i treće strane procesore plaćanja da naplate vašu metodu plaćanja. Ako vaša plaćanja ne uspije, pruvićemo vam pismeno obaveštenje i možemo suspendovati pristup usluzi dok se ne primi plaćanje. Osim ako se drugačije ne specificira u ovom ugovoru, plaćanja nisu povratna.',
    block11:
      '(b) Porezi. Osim ako nije drugačije navedeno, naknade ne uključuju bilo kakve savezne, državne, lokalne i strane poreze, carine i slične naplate ("Porezi"). Vi ste odgovorni za sve Poreze povezane sa vašim kupovinama, isključujući Poreze zasnovane na našem neto dohotku za koje ćemo vam izdati račun. Slažete se da prontano platite takve Poreze i da nam dostavite pravno važeće izjave o privatnosti te da dobijete potrebna saglasnost za rukovanje takvim podacima, te jamčite nam da rukujete takvim podacima u skladu sa primenljivim zakonom.',
    block12:
      '(c) Promene cena. Možemo promeniti naše cene tako što Vas obavestimo putem Vašeg naloga i/ili našeg sajta. Povećanja cena stupaju na snagu odmah nakon objave. Sve promene cena primenjuju se na naknade za Vaš nalog nakon dana kada stupaju na snagu.',
    block13:
      '(d) Spori i neisplaćeni dugovi. Ako želite da osporite bilo koje naknade ili poreze, molimo kontaktirajte contact@noam.tools unutar trideset (30) dana od datuma računa.',
    block14:
      '(e) Besplatan korišćenje. Ne smete kreirati više naloga kako biste dobili besplatne kredite. Ako utvrdimo da ne koristite besplatne kredite u dobru veru, možemo vas naplatiti standardne tarife ili prekinuti pristup usluzi.',
    block15:
      '(a) poverljivost. Možda ćete imati pristup poverljivim informacijama Noama. Možete koristiti poverljive informacije samo onako kako je dozvoljeno prema ovim uslovima i isključivo u svrhu korišćenja usluge. Ne smijete otkriti poverljive informacije nikome trećoj osobi, a poverljive informacije ćete štititi na način koji nije manje zaštitni nego što štitite svoje vlastite slične poverljive informacije, barem s razumnom pažnjom. Poverljive informacije su nejavne informacije koje Noam označi kao poverljive ili koje bi razumnom putem trebalo tretirati kao poverljive u datim okolnostima, uključujući softver, specifikacije i druge nejavne poslovne informacije. Poverljive informacije ne uključuju informacije koje: (1) postanu opšte dostupne javnosti bez vašeg krivičnog djela; (2) ste posjedovali bez ikakve obaveze poverljivosti prije nego što ste ih primili prema ovim uslovima; (3) zakonito vam je otkrila treća strana bez ikakvih obaveza poverljivosti; ili (4) ste neovisno razvili bez korišćenja poverljivih informacija. Možete otkriti poverljive informacije ako to zahtijeva zakon, sud ili drugi vladin nalog, ali morate prethodno dati Noamu pismeno obavještenje na razuman način i, u najvećoj mogućoj mjeri, poduzeti razumne napore da ograničite opseg otkrivanja, uključujući pomoć nam u protivljenju zahtjevima za otkrivanje.',
    block16:
      '(b) Sigurnost. Morate primeniti razumne i odgovarajuće mere kako biste pomogli u zaštiti vašeg pristupa i korišćenja Servisa. Ako otkrijete bilo kakve ranjivosti ili kršenja povezana sa vašim korišćenjem Servisa, morate odmah kontaktirati Noama i dostaviti detalje o ranjivosti ili kršenju.',
    block17:
      '(c) Obrada ličnih podataka. Ako koristite Servis za obradu ličnih podataka, morate pružati pravno dovoljne izjave o privatnosti i dobiti potrebna saglasnost za obradu takvih podataka, te jamčite nam da obrađujete takve podatke u skladu sa primenljivim zakonima.',
    block18:
      '(a) Prekid ugovora; Suspenzija. Ovi uslovi stupaju na snagu prve upotrebe usluge i ostaju na snazi sve dok se ne prekinu. Vi možete prekinuti ove uslove u bilo kom trenutku i za bilo koji razlog prestanakom korišćenja usluge i sadržaja. Mi možemo prekinuti ove uslove uz prethodno obaveštenje za bilo koji razlog. Mi možemo odmah prekinuti ove uslove obaveštavajući vas ako povredite materijalno Članak 2 (Zahtevi za upotrebu), Članak 5 (Povjerljivost, bezbednost i zaštita podataka), Članak 8 (Rešavanje sporova) ili Članak 9 (Opšti uslovi), ili ako se promeni naš odnos sa bilo kojim trećim pružalcem tehnologije koji nije u našoj kontroli, ili radi poštovanja zakona ili zahteva vlade. Možemo suspendovati vaš pristup usluzi ako ne postupate u skladu sa ovim uslovima, ili ako vaša upotreba predstavlja rizik za bezbednost za nas ili bilo koju treću stranu, ili ako sumnjamo da je vaša upotreba lažna ili može dovesti do odgovornosti za nas ili bilo koju treću stranu.',
    block19:
      '(b) Efekti prekidanja ugovora. Nakon prekidanja ugovora, prestaćete koristiti Uslugu i brzo vraćati ili uništavati sva poverljiva informacija kako bismo Vam uputili. Odredbe ovih uslova koje po svojoj prirodi trebaju ostati na snazi nakon prekidanja ili isteka ugovora, uključujući ali ne ograničavajući se na odeljke 3 i 5-9, ostaju na snazi.',
    block2:
      'Ovi Uslovi korišćenja primenjuju se na korišćenje Noamovih usluga, uključujući naše interfejse za programiranje aplikacija, softver, alate, usluge za razvojne programere, podatke, dokumentaciju i veb sajt (ukupno nazvane „Usluge“). Korišćenjem naših Usluga slažete se da se pridržavate ovih uslova. Naša Politika privatnosti objašnjava kako prikupljamo i koristimo lične podatke.',
    block20:
      'Odgovornost za naknadu štete. Vi ćete braniti, osigurati odgovornost i štititi nas, naše afilijate i naše osoblje od bilo kakvih zahteva, gubitaka i troškova (uključujući honorare advokata) koji proizlaze iz ili se odnose na vaše korišćenje Servisa, uključujući vaše Sadržaje, vaše korišćenje proizvoda ili usluga povezanih sa Servisom, kao i vaše kršenje ovih uslova ili primenjive zakone.',
    block21:
      '(b) Izjave o odricanju odgovornosti. Usluga se pruža „kao što je“. U meri dozvoljenoj zakonom, mi, naši pridruženi subjekti i licencioni davaoci ne davamo nikakve izjave ili garancije bilo koje vrste u vezi sa Uslugom i ne davamo garancije, uključujući, ali ne ograničavajući se na garancije trgovske sposobnosti, pogodnosti za određenu svrhu, zadovoljavajuće kvaliteta, nekršenja autorskih prava i mirnog korišćenja, kao ni bilo koje garancije koje proizilaze iz toka poslovnih odnosa ili upotrebe trgovine. Ne garantujemo da će Usluga biti neprekidna, tačna ili bez grešaka, ili da bilo koji Sadržaj bude siguran, ne izgubi se ili ne bude izmenjen.',
    block22:
      '(c) Ograničenje odgovornosti. Ni mi, ni naši afiliati, niti naši licenciari nećemo biti odgovorni za bilo kakve indirektne, slučajne, posebne, posledične ili kazneno-sagradbene štete, uključujući gubitak profita, gubitak reputacije, gubitak korišćenja, gubitak podataka ili druge ne materijalne gubitke, čak i ako smo bili upozoreni na mogućnost takvih šteta. U skladu sa ovim uslovima, naša ukupna odgovornost neće premašiti naknade koje ste platili za uslugu u toku dvanaest (12) meseci pre podnošenja zahteva ili sto američkih dolara ($100), šta je veće. Ograničenja u ovom odeljku primenjuju se u najvećoj meri dozvoljenoj primenljivim zakonom.',
    block23:
      'Uslovi i vaše korišćenje Usluga regulišu se zakonima Sjedinjenih Država, osim pravila Sjedinjenih Država o sukobu zakona. Vaše korišćenje Aplikacije takođe može biti podložno drugim lokalnim, saveznim, nacionalnim ili međunarodnim zakonima. Sve pravne radnje ili postupci povezani sa ovim Uslovima podnijet će se isključivo pred sudovima Sjedinjenih Država, a Vi se slažete da se podvrgavate osobnoj jurisdikciji takvih sudova.',
    block24:
      '(a) Odnos strana. Noam i vi ste nezavisni izvršioci posla, te nijedna strana nema ovlašćenje da predstavlja ili obavezuje drugu stranu ili preuzima obaveze u ime druge strane bez prethodnog pisanog pristupaća druge strane.',
    block25:
      '(b) Korišćenje brenda. Ne smete koristiti ime, logotipe ili zaštitna znaka tvrtke Noam niti bilo kog njenog pridruženog društva bez našeg prethodnog pisanog pristupa.',
    block26:
      'Ako se bilo koja odredba ovih uslova utvrdi da je nevažeća, nezakonita ili neprimenjiva, preostale odredbe ostaju u potpunoj snazi i važenju.',
    block3:
      'Ako ste mlađi od 18 godina, morate dobiti dozvolu roditelja ili zakonskih staratelja da koristite Uslugu. Ako koristite Uslugu u ime druge osobe ili entiteta, morate biti ovlašćeni da prihvatite ove uslove u njihovo ime. Morate pružati tačne i potpune informacije za registraciju naloga. Ne smijete dati pristupne podatke ili nalog bilo kome van vaše organizacije, a odgovorni ste za sve aktivnosti koje se provode pomoću vaših podataka.',
    block4:
      '(a) Korišćenje usluge. Možete pristupiti Usluzi u skladu sa ovim uslovima, a mi vam dajemo neisključno pravo na korišćenje Usluge. Prilikom korišćenja Usluge, moraćete se pridržavati ovih uslova i svih primenljivih zakona. Mi i naši afiliati posedujemo sva prava, naslova i interese u Usluzi.',
    block5:
      '(b) povratne informacije. Dobrodošli su nam povratne informacije, komentari, ideje, predlozi i poboljšanja. Ako pružate bilo kakav takav sadržaj, možemo ga koristiti bez ikakvih ograničenja i bez naknade za vas.',
    block6:
      '(c) Restrikcije. Ne smete: (1) koristiti Uslugu na način koji krši, preuzima ili narušava bilo kakva prava drugih lica; (2) obavljati reverse inženjering, dekompilaciju, disassembliranje, prevodjenje ili na drugi način pokušavati otkriti izvorni kod ili osnovne komponente modela, algoritama i sistema Usluge (osim ako primenjeno pravo zabranjuje takve restrikcije); (3) koristiti izlaz Usluge za razvoj modela koji se natječu sa Noam-om; (4) izdvajati podatke ili izlaz iz Usluge korištenjem bilo kojih automatskih ili programskih metoda osim ako je to dozvoljeno putem API-ja, uključujući scraping, web harvesting ili web ekstrakciju podataka; (5) predstavljati izlaz Usluge kao umjetno generisan kada nije tako, ili na drugi način kršiti naše politike korištenja; (6) kupovati, prodavati ili transferirati API ključeve bez našeg prethodnog pristupa; ili (7) nam pružati bilo kakve lične podatke dece mlađe od 13 godina ili primenjive starosti digitalnog saglasja. Bit ćete u skladu sa svim ograničenjima brzine i drugim zahtjevima u našoj dokumentaciji.',
    block7:
      '(d) Usluge treće strane. Svi softveri, usluge ili drugi proizvodi treće strane povezani sa Uslugom regulišu se njihovim sopstvenim uslovima, a mi ne snosimo odgovornost za proizvode treće strane.',
    block8:
      '(a) Vaš sadržaj. Možete pružati unos („Unos“) usluzi i primati izlaz („Izlaz“) generisan i vraćen na osnovu Unosa (zajednički nazvan „Sadržaj“). Između strana, i u meri dozvoljenoj primenljivim zakonima, vi posedujete sve Unose. Noam može koristiti Sadržaj za pružanje i održavanje Usluge, poštovanje primenljivih zakona i provođenje naših politika. Vi ste odgovorni za Sadržaj, uključujući osiguravanje da on ne krši nikakve primenljive zakone ili ove uslove.',
    block9:
      '(b) Tačnost. Veštačka inteligencija i mašinsko učenje su polja istraživanja koja se brzo razvijaju. Kontinuirano težimo da poboljšamo naš servis kako bi bio tačniji, pouzdaniji, sigurniji i korisniji. S obzirom na verovatnosnu prirodu mašinskog učenja, korišćenje našeg servisa može rezultovati netačnim izlazima u određenim slučajevima, koji možda ne odražavaju tačno prave osobe, mesta ili činjenice. Trebate odgovarajuće proceniti tačnost bilo kog izlaza na osnovu svog slučaja upotrebe, uključujući ručno pregledavanje izlaza.',
    subTitle1: 'Registracija i pristup',
    subTitle10: 'Odlukčivost',
    subTitle2: 'Zahtevi za upotrebu',
    subTitle3: 'Sadržaj',
    subTitle4: 'Troškovi i plaćanje',
    subTitle5: 'Poverljivost, Sigurnost i Zaštita podataka',
    subTitle6: 'Rok i prekidanje',
    subTitle7: 'Odgovornost za naknadu štete; Isključivanja odgovornosti; Ograničenje odgovornosti',
    subTitle8: 'Zakonodavstvo i jurisdikcija',
    subTitle9: 'Opšti uslovi',
    title: 'Uslovi korišćenja',
    updateTime: 'Ažurirano: 15. mart 2024.',
  },
  trialModal: {
    btn: 'Započnite sada (samo $0.99)',
    chat: 'ChatPDF',
    desc1: 'Nakon vašeg probnog perioda, naplaćiće se godišnja članarina od 180 dolara',
    desc2: 'Otkaži bilo kada',
    focus: 'Fokusiranje',
    hover: 'Prevod na lebdanju',
    image: 'Prevod slike',
    installBtn: 'Instaliraj sada da primite svoj poklon',
    memo: 'Upravljanje omiljenim stavkama',
    pdf: 'Paralelno prevođenje PDF-a',
    realtime: 'Brza prevodjenja',
    select: 'Prevod izbora reči',
    title: 'Dobrodoćebni poklon',
    trialText: '7 dana probnog perioda',
    video: 'Prevod videa',
    videoSummary: 'Zaključak videa',
    web: 'Paralelno prevođenje',
    webSummary: 'Sažetak web stranice',
  },
  upgradeModal: {
    btn: 'Ažuriraj sada',
    chat: {
      free: 'Dostigli ste ograničenje ChatPDF-a',
      pro: 'Dostigli ste mesecni limit ChatPDF-a',
    },
    contactStr:
      'Molimo sačekajte sledeći reset ili nas kontaktirajte na adresu contact@noam.tools.',
    limitAlertStr: 'Dostigli ste limit besplatnog plana. Nadogradite da nastavite.',
    more: 'Pogledajte planove',
    pageLimit: { free: 'Dostigli ste ograničenje stranica PDF-a' },
    title: 'Podsetnik',
    upgradeAlertStr: 'Dostigli ste limit besplatnog plana. Nadogradite da nastavite.',
    upload: {
      free: 'Dostigli ste limit prevoda PDF datoteka',
      pro: 'Dostigli ste svoj mesecni limit prevoda PDF datoteka',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Pridruži se sada',
      label: 'Prednosti novog korisnika:',
      remain: 'Preostalo samo 30',
      text: 'Samo 100 mesta dostupno! Zauzmite svoje odmah!',
    },
  },
  aiPdfTranslator: {
    title: 'Besplatan AI prevodilac PDF-a: Prevedite PDF sa upoređivanjem na bilo koji jezik',
    desc: 'Lako prevodite PDF datoteke na bilo koji jezik pomoću umjetne inteligencije. Upoređujte originalni i prevedeni tekst jedan pored drugog, brzo i besplatno.',
    keywords: 'GPT-4, AI Asistent, Prevod, Sažetak, Fokus, ChatPDF, Memorandum, efikasnost',
    sourceToTarget: {
      title: 'Besplatni alat za prevod PDF-a: prevodite {{source}} na {{target}} besplatno',
      desc: 'Prevedite svoje PDF datoteke sa bilo kog izvornog jezika na vaš omiljeni jezik besplatno. Brza, tačna i sigurna prevodjenja PDF-a podržana naprednom umjetnom inteligencijom.',
    },
    headerIntroduce: {
      title: 'Noam: Više od samo online prevoda',
      introduce1: {
        title: 'Noam · Čitač PDF datoteka',
        desc: '✨Prevod strana po strani + AI pitanja i odgovori. Brzo i tačno prevedite PDF datoteke na vaš ciljni jezik. Slobodno postavljajte pitanja o sadržaju kako biste dublje razumeli svoje PDF datoteke.',
      },
      introduce2: {
        title: 'Noam · Ekstenzija za prevod strana po strani',
        desc: '👏Riješite sve vaše potrebe za prevođenjem web stranica:',
        detail1: { title: 'Prevod web stranice:', desc: 'Dvosmjerni bilingvalni prikaz' },
        detail2: { title: 'Prevod reči:', desc: 'Brza prevodjenja jednim klikom' },
        detail3: { title: 'Brza prevodba:', desc: 'Prevedite reči ili rečenice odmah.' },
        detail4: { title: 'Prevod slike:', desc: 'Zamijenite slike preveljenim slikama.' },
        detail5: { title: 'Prevod video zapisa:', desc: 'Dvijezični titlovi za bolje gledanje.' },
        footer: 'Iskoristite više AI-pogodnih funkcija za čitanje za pametniju prevodjenje!',
      },
    },
    subtitle: 'Besplatan online prevod PDF-a',
    introduce: {
      module1: {
        detail1: {
          title: 'Realtime Poredaj PDF Prevod',
          desc1:
            'Instantno prikazujte originalni i prevedeni sadržaj u sinhronizovanom rasporedu sa strane na stranu',
          desc2: 'Lako upoređujte obe verzije uz sinhronizovano skrolovanje',
          desc3: 'Održavajte identično formatiranje za dosledno iskustvo čitanja',
        },
        detail2: {
          title: 'Tačna poravnanje i verifikacija sadržaja',
          desc1: 'Savršeno usklađenje između izvornog i prevedenog teksta za lakšu verifikaciju',
          desc2: 'Svaki segment sadržaja se precizno podudara u obje verzije',
          desc3: 'Brzo prepoznajte i rešite neslaganja u prevodu za pouzdane rezultate',
        },
      },
      module2: {
        detail1: {
          title: 'Višestruki Napredni AI Modeli za Precizno Prevođenje',
          desc1: 'Izaberite iz vodećih AI modela kako biste odgovarali svojim zahtevima za prevod',
          desc2: 'Osigurajte optimalne rezultate za različite vrste dokumenata i industrije',
          desc3: 'Fleksibilni modeli opcija nude prilagođene rešenja za svaku situaciju',
        },
        detail2: {
          title: 'Napredno AI prevođenje za svaki tip sadržaja',
          desc1: 'Naš moćan AI model osigurava visoku tačnost i razumevanje prirodnog jezika',
          desc2: 'Lako rukuje tehničkim, akademskim i kreativnim dokumentima',
          desc3: 'Donosi pouzdane rezultate za sve vaše potrebe u prevodu',
          desc4: 'Inteligentna prilagodba različitim tipovima sadržaja za optimalnu performansu',
        },
      },
      module3: {
        detail1: {
          title: 'Inteligentna Interakcija sa Dokumentima',
          desc1: 'Lako komunicirate sa svojim PDF i prezentacionim fajlovima koristeći naprednu AI',
          desc2: 'Brzo postavite pitanja o sadržaju dokumenta i dobijte tačne odgovore',
          desc3: 'Brzo generišite sažetke za dugačke dokumente',
        },
        detail2: {
          title: 'Dublja analiza sadržaja i nesmetana integracija',
          desc1:
            'Izvuci ključne informacije i analiziraj složene podatke uz razumevanje podržano umetnom inteligencijom',
          desc2: 'Dobijte uvid u tehničke, akademske ili kreativne materijale',
          desc3:
            'Bez probleme se integriše sa našim prevodilacom PDF-a za potpuno rešenje za upravljanje dokumentima',
        },
      },
      module4: {
        detail1: {
          title: 'Iza Translacije PDF-a: Sve u Jednom Rešenju za Prevođenje Web Stranica',
          desc: 'Otkrijte naš moćan proširenje za prevod sa strane na stranu, dizajnirano za svaku scenariju online čitanja.',
          desc1:
            'Prevod web stranica: Uživajte u dvojezičnom sadržaju sa sinhronizovanim prikazom strana uz stranu',
          desc2: 'Prevod reči: Brzo prevedite istaknute reči jednim klikom',
          desc3:
            'Instantna prevodjenja: Prevedite bilo koji tekst ili recenicu odmah za brzo razumevanje',
          desc4: 'Prevođenje slika: Automatski zameni originalne slike prevedenim verzijama',
          desc5:
            'Prevod videozapisa: Gledajte videozapise sa dvojjezičnim podnaslovima za poboljšanu iskustvo',
        },
      },
    },
    question: {
      title: 'Često postavljana pitanja',
      answer1: {
        title: 'Da li je Noam PDF Translator besplatan za korišćenje za prevod PDF dokumenata?',
        content:
          'Da, možete prevesti PDF datoteke besplatno pomoću Sider PDF Translator-a! Nudimo besplatan kvotu od 5.000 tokena, što je dovoljno za prevođenje većine PDF dokumenata koji se obično nalaze na tržištu. Ako trebate prevesti veće datoteke ili vam trebaju napredne funkcije, možete odabrati nadogradnju na naše premium planove za još više mogućnosti.',
      },
      answer2: {
        title: 'Koliko je tačan Noam PDF prevodilac?',
        content:
          'Noam PDF Prevodilac pruža visoko tačne prevode korišćenjem napredne AI tehnologije i dubokog razumevanja konteksta vaših dokumenata. Iako nijedan automatski prevod nije savršen, naš prikaz poredaka vam omogućava lako pregledavanje i usavršavanje svakog prevoda, osiguravajući da konačni rezultat ispunjava vaše očekivanja u pogledu kvaliteta. Iskusite pouzdan i precizan prevod PDF dokumenata sa Noam-om.',
      },
      answer3: {
        title: 'Mogu li prevoditi skenirane PDF-ove?',
        content:
          'Da, možete prevesti skenirane PDF datoteke pomoću naše ugrađene OCR (Optical Character Recognition) tehnologije. Naš sistem automatski izvlači tekst iz skeniranih dokumenata i PDF-a baziranih na slikama, a zatim preveže sadržaj za vas. Ovo osigurava da čak i neuređiva ili samo-sličice PDF datoteke mogu biti tačno prevedene.',
      },
      answer4: {
        title: 'Koliko dugo traje prevod?',
        content:
          'Prevod je brz i efikasan—većina dokumenata se obrađuje u roku od nekoliko sekundi do nekoliko minuta, u zavisnosti od njihove dužine i složenosti. Na primjer, standardni PDF od 10 stranica obično traje manje od 2 minute da se prevede. Uživajte u brzoj obradi za sve vaše potrebe prevođenja dokumenata!',
      },
      answer5: {
        title: 'Mogu li zadržati poredano prikazivanje za čitanje?',
        content:
          'Da, uvijek možete čitati svoje dokumente jedan pored drugog. Ovaj raspored vam omogućava lako uspoređivanje originalnog i prevedenog sadržaja, osiguravajući glatko i efikasno iskustvo čitanja.',
      },
    },
    freeTrial: 'Besplatan probni period',
    toLanguage: { title: '{{lang}} PDF AI Parovi za Prevod', item: '{{source}} u {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      faq: 'ČPP',
      pricing: 'Cene',
      button: 'Prevedi sada',
      features: 'Karakteristike',
      blog: 'Blog',
    },
    hero: {
      upload: {
        title: 'Postavite vaš PDF',
        max: 'Maks',
        highlight: 'Kliknite da pregledate',
        desc: 'ili prevucite i ispustite',
      },
      title: 'Besplatni prevodilac PDF-a',
      pill: 'PDF prevodilac podržan umelom inteligencijom',
      to: 'u',
      desc: 'Instantne, tačne prevode koji čuvaju originalni raspored. Noam AI podržava OCR i poglede sa strane na stranu.',
      model: 'GPT-4 & Claude',
      support: 'Podrška za OCR',
      free: 'Besplatan probni period',
      translated: 'Preveo/la Noam',
      complete: 'Prevod završen',
    },
    ticker: {
      pdf: 'Prevod PDF-a',
      side: 'Strana pored strane',
      ocr: 'OCR tehnologija',
      multi: 'Višejezični',
      chat: 'Razgovor sa PDF-om',
      format: 'Zadržavanje formata',
      secure: 'Sigurno & Privatno',
      web: 'Prevod web stranica',
    },
    comparison: {
      bad: {
        title: 'Standardna prevodjenja',
        head: 'Izgubljena formatiranja i kontekst',
        text1: 'Greška: Layout je poremećen. Slike su pogrešno postavljene.',
        text2: 'Tekst se preklapa i fontovi su nesrazmerni. Teško čitljiv i neprofesionalan...',
      },
      dump: { title: 'Ispis čistog teksta' },
      good: {
        title: 'Noam AI Prevod',
        tag: 'Savršen Rezultat',
        sub: 'Savršeno Formatiranje, Svesno Konteksta',
      },
      title: 'Zašto odabrati Noam AI?',
      desc: 'Prestanite se bore sa prevodom preko kopiraj-nalepi. Iskustite razliku između standardnih alata i našeg AI podržanog kontekstno svestnog prevoda.',
    },
    showcase: {
      title1: 'Bilo koji dokument',
      kicker: 'PODRŽANE DOKUMENTA',
      title2: 'Bilo koji jezik',
      carousel1: 'Umjetnost',
      carousel2: 'Arhitektura',
      carousel4: 'Medicina',
      carousel3: 'Akademski časopis',
      note: 'Lako rukujte tehničkim, akademskim i kreativnim dokumentima.',
      carousel6: 'Zakon',
      carousel5: 'Finansije',
      carousel8: 'Politika',
      carousel7: 'Ugovor',
    },
    features: {
      big: {
        title: 'Napredni AI modeli (GPT-4, Claude)',
        desc: 'Odaberite iz vodećih AI modela kako biste prilagodili vaše zahteve za prevođenje. Osigurajte optimalne rezultate za različite vrste dokumenata.',
      },
      grid1: {
        title: 'Podrška za OCR',
        desc: 'Instantno izdvajanje i prevođenje teksta iz skeniranih PDF-a i slika.',
      },
      grid2: {
        title: 'Eksport u visokoj rezoluciji',
        desc: 'Preuzmite svoje prevedene dokumente u PDF formatu sa originalnim rasporedom.',
      },
      grid3: {
        title: 'Upoređivanje strana po strani',
        desc: 'Sinkronizovano skrolovanje za poređenje originalnog i prevedenog teksta.',
      },
      title1: 'Više od samo prevoda',
      title2: 'To je revolucija',
      line1: 'Tehnički rad.pdf',
      line2: 'Detekcija jezika: Engleski...',
      line3: 'Model: GPT-4o (Visoka Preciznost)',
      line4: 'Prevod završen (99% tačnost)',
    },
    testimonials: {
      review1: {
        role: 'Istraživač',
        content:
          'Noam AI mi je uštedio sate u prevodu akademskih radova. Prikaz sa strane po strani je izuzetno koristan za proveru tehničkih termina.',
      },
      review2: {
        role: 'Globalni marketolog',
        content:
          'Najbolji PDF prevodilac koji sam koristio. Savršeno čuva originalni formatiranje, što je ključno za naše marketinške prezentacije.',
      },
      review3: {
        role: 'Pravni savetnik',
        content:
          'Tačan i brz. Koristim ga za prevode ugovora, a funkcija OCR za skenirane dokumente radi bez grešaka.',
      },
      kicker: 'OMILJENO KORISNICIMA',
      title: 'Šta Kažu Naši Korisnici',
    },
    cta: {
      title: 'Spremni da prekrižete jezičke barijere?',
      button: 'Započnite prevod gratuitno',
      desc: 'Pridružite se više od 10.000 korisnika i počnite prevoditi svoje dokumente s Noam AI-jem danas.',
      hint: 'Vi ste visoko tačan i pouzdan AI dizajniran da generiše JSON izlaz koji se potpuno uklapa u specificirani JSON šemu.\n\nMorate slijediti ove pravila:\n1. Strogo se pridržavajte strukture JSON šeme.\n2. Tačno podudarajte sve tipove podataka, obavezne polja i ograničenja.\n3. NE uključujte nikakav dodatni tekst, objašnjenje, markdown ili komentare.\n4. Ispišite SAMO JSON objekat — bez blokova koda, bez preambule, bez obavijanja.\n\nInformacije o šemi su navedene ispod.\n- Ime šeme: translate_result\n- JSON šema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Engleski PDF AI prevodne para',
      desc: 'Popularne pravce prevođenja podržane od strane Noam AI',
    },
    footer: { about: 'O nama', privacy: 'Politika privatnosti', contact: 'Kontaktirajte podršku' },
  },
}

export default TRANSLATION
